import { watch, ref, onUnmounted } from 'vue'
import { useFormStore } from '@/stores/form'
import client_lookup from '@/assets/json/clientLookups.json'

const sponsoredConditionWatch = () => {
  const humanExceptionStatusIdWatch = ref()
  const formStore = useFormStore()

  humanExceptionStatusIdWatch.value = watch(
    () => formStore.form.values.humanExceptionStatusId,
    (newVal) => {
      formStore.extraMap.disableHumanException = false
      formStore.form.resetField('humanExceptionRequestTypeId')

      if (!newVal) return

      const {
        humanExceptionStatus: { OutsideCountry, InsideCountry, NewBornInsideCountry },
        humanExceptionRequestType: { entryPermit, IssueResidencyForNewBornInsideUAE }
      } = client_lookup

      if (newVal == OutsideCountry) {
        formStore.form.setFieldValue('humanExceptionRequestTypeId', entryPermit)
        formStore.extraMap.disableHumanException = true
      }

      if (newVal == InsideCountry) {
        formStore.form.resetField('humanExceptionRequestTypeId')
      }

      if (newVal == NewBornInsideCountry) {
        formStore.form.setFieldValue(
          'humanExceptionRequestTypeId',
          IssueResidencyForNewBornInsideUAE
        )
        formStore.extraMap.disableHumanException = true
      }
    }
  )
  onUnmounted(() => {
    humanExceptionStatusIdWatch.value && humanExceptionStatusIdWatch.value()
  })
}
const humanExceptionRequestTypeWatch = () => {
  const humanExceptionRequestTypeIdWatch = ref()
  const formStore = useFormStore()
  humanExceptionRequestTypeIdWatch.value = watch(
    () => formStore.form.values.humanExceptionRequestTypeId,
    (newVal) => {
      if (!newVal) return
      formStore.extraMap = {
        ...formStore.extraMap,
        entryPermitMSG: newVal == 1 ? true : false,
        issuingResidencyMSG: newVal == 21 ? true : false,
        renewResidenceMSG: newVal == 2 ? true : false
      }
    }
  )
  onUnmounted(() => {
    humanExceptionRequestTypeIdWatch.value && humanExceptionRequestTypeIdWatch.value()
  })
}
export default function () {
  return {
    sponsoredConditionWatch,
    humanExceptionRequestTypeWatch
  }
}
